import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/mallApp/app_bg.png'


const _hoisted_1 = { class: "page_container" }
const _hoisted_2 = {
  class: "page_title",
  "data-aos": "fade-down",
  "data-aos-duration": "800"
}
const _hoisted_3 = {
  class: "page_content",
  "data-aos": "fade-up",
  "data-aos-duration": "800",
  "data-aos-delay": "200"
}
const _hoisted_4 = {
  class: "app_btn_content",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "300"
}
const _hoisted_5 = { class: "app_btns" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "app_img",
  "data-aos": "fade-right",
  "data-aos-duration": "800",
  "data-aos-delay": "600"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_btn = _resolveComponent("custom-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.des), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btns, (item, index) => {
          return (_openBlock(), _createBlock(_component_custom_btn, {
            key: index,
            config: item,
            onClick: ($event: any) => (_ctx.onDownload(index)),
            "data-aos": "fade-left",
            "data-aos-duration": "800",
            "data-aos-delay": 500 + index * 150
          }, null, 8, ["config", "onClick", "data-aos-delay"]))
        }), 128))
      ]),
      _hoisted_6
    ])
  ]))
}